import React, { useEffect, useState, useRef } from 'react';
import { FixedBottomBar, HeaderBox } from './mBookListPage'; // Assuming these are well-defined elsewhere
import { Avatar, Box, IconButton, TextField, Typography, Grid, Button, CircularProgress, Drawer, List, ListItem, ListItemText, ListItemIcon, InputAdornment, InputBase } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import i18n, { _get_i18Lang } from '../../i18n';
import dummyImage from "../../../src/Images/no_image_square.jpg";
import ProfileService from "../../Services/Profile";
import IndianFlag from "../../Images/flag-India.png";

// Import react-phone-input-2
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

const MobileProfilePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [userData, setUserData] = useState<any>();
  const [profileData, setProfileData] = useState<any>({
    name: '',
    phone: '',
    email: '',
    address1: '',
    address2: '',
    country: '',
    state: '',
    city: '',
    pincode: '',
  });
  const [loading, setLoading] = useState(false);
  const [profileMessage, setProfileMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [userImg, setUserImg] = useState('');
  const [openImageDrawer, setOpenImageDrawer] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const cameraInputRef = useRef<HTMLInputElement>(null);

  // Define all fields in the desired display order
  const orderedProfileFields = [
    { id: 'name', label: t('Full Name'), type: 'text' },
    { id: 'phone', label: t('Mobile Number'), type: 'phone' },
    { id: 'email', label: t('Email Address'), type: 'email', disabled: true },
    { id: 'address1', label: t('Address Line 1') },
    { id: 'address2', label: t('Address Line 2') },
    { id: 'country', label: t('Country') },
    { id: 'state', label: t('State') },
    { id: 'city', label: t('City') },
    { id: 'pincode', label: t('Pin code'), type: 'number' },
  ];

  // Fetch profile data on component mount
  useEffect(() => {
    const language = _get_i18Lang();
    ProfileService.getProfile(language)
      .then((res) => {
        if (res && res.result) {
          setUserName(res.result.name);
          setUserData(res.result);
          setProfileData({
            name: res.result.name || '',
            phone: res.result.phoneNumber || '',
            email: res.result.email || '',
            address1: res.result.address1 || '',
            address2: res.result.address2 || '',
            country: res.result.country || '',
            state: res.result.state || '',
            city: res.result.city || '',
            pincode: res.result.pinCode || '',
          });
          setUserImg(res.result.imagePath || '');
          setErrorMessage(null);
        } else {
          setErrorMessage(t('Failed to load profile data.'));
        }
      })
      .catch((error) => {
        console.error("API Call Error:", error);
        setErrorMessage(t('Failed to load profile data.'));
      });
  }, [t, i18n.language]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setProfileData((prevData: any) => ({
      ...prevData,
      [id]: value,
    }));
  };

  // const handlePhoneChange = (phone:  any) => {
  //   setProfileData((prevData: any) => ({
  //     ...prevData,
  //     phone: phone,
  //   }));
  // };
  const handlePhoneChange = (event: any) => {

    setProfileData({
      ...profileData,
      phone: event.target.value,
    });
  };
  const handleOpenImageDrawer = () => {
    setOpenImageDrawer(true);
  };

  const handleCloseImageDrawer = () => {
    setOpenImageDrawer(false);
  };

  const handleImageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedImageFile(file);
      setUserImg(URL.createObjectURL(file)); // For immediate UI preview
    }
    handleCloseImageDrawer();
    // Clear the input to allow selecting the same file again if needed
    if (event.target) {
      event.target.value = '';
    }
  };

  const handleUpdateProfile = async () => {
    setLoading(true);
    setProfileMessage('');
    setErrorMessage(null);

    try {
      let baseFile: string | null = null;
      if (selectedImageFile) {
        baseFile = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(selectedImageFile);
        });
      }

      const countryTypeToSend = userData?.countrytype || '';
      const apiLanguage = _get_i18Lang();

      const response = await ProfileService.updateUserProfile(
        profileData.name,
        profileData.email,
        baseFile,
        profileData.address1,
        profileData.address2,
        profileData.city,
        profileData.state,
        profileData.country,
        countryTypeToSend,
        profileData.pincode,
        apiLanguage,
        profileData.phone
      );

      if (response?.result) {
        setProfileMessage(t('Profile updated successfully!'));
        setUserName(response.result.name);
        setUserData(response.result);
        setUserImg(response.result.imagePath || userImg);
        setSelectedImageFile(null);
        setErrorMessage(null);
      } else {
        if (response?.message && response.message.toLowerCase().includes("already exist")) {
          setErrorMessage(t('Mobile number already exists.'));
        } else {
          setErrorMessage(response?.message || t('Failed to update profile.'));
        }
        setProfileMessage('');
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      setErrorMessage(t('An error occurred while updating profile.'));
      setProfileMessage('');
    } finally {
      setLoading(false);
    }
  };


  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <HeaderBox>
        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: { xs: 20, sm: 35 }, p: 0 }}>
          <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
        </IconButton>
        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: { xs: 20, sm: 35 }, p: 0 }}>
          <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
        </IconButton>
        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
          {t("shrihari_tr")}
        </Typography>
        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
          {t("Profile_tr")}
        </Typography>
      </HeaderBox>

      {/* Main content area, designed for scrolling */}
      <Box
        sx={{
          flexGrow: 1, // Allows this box to take available space
          overflowY: 'auto', // Enables vertical scrolling
          msOverflowStyle: 'none', // For IE/Edge
          scrollbarWidth: 'none', // For Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // For Chrome/Safari
          },
          pb: 2, // Padding at the bottom, so content doesn't get cut by potentially fixed elements
        }}
      >
        {/* Avatar and Name Section */}
        <Box sx={{ position: 'relative', height: 200, overflow: 'hidden' }}>
          <Avatar
            src={userImg || dummyImage}
            sx={{ height: '100%', width: "100%", cursor: 'pointer', objectFit: 'cover' }}
            variant="square"
            onClick={handleOpenImageDrawer}
            alt="User Profile"
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              color: 'white',
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              boxShadow: '0px -5px 8px 5px rgba(0, 0, 0, 0.3)',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              {userName || t("Guest_User_tr")}
            </Typography>
          </Box>
        </Box>

        {/* Profile Form */}
        <Box sx={{ p: 2, pt: 3 }}>
          <Grid container spacing={2}>
            {orderedProfileFields.map((field) => (
              <Grid item xs={12} key={field.id}>
                {field.type === 'phone' ? (
                  <>
                    {/* <PhoneInput
  country={'in'}             // Ensures it starts as India
  disableDropdown={true}     // CRITICAL: Disables the country dropdown completely
  countryCodeEditable={false} // Prevents editing the country code
  value={profileData.phone}
  onChange={handlePhoneChange}
  disabled={userData?.loginMethod === 'mobile'}
  inputStyle={{
    width: '100%',
    fontSize: '0.8rem',
    height: '40px',
    borderRadius: '4px',
    borderColor: '#c4c4c4',
    backgroundColor: userData?.loginMethod === 'mobile' ? '#f5f5f5' : 'inherit',
    cursor: userData?.loginMethod === 'mobile' ? 'not-allowed' : 'text',
    caretColor: userData?.loginMethod === 'mobile' ? 'transparent' : 'auto',
  }}
  containerStyle={{ width: '100%' }}
  buttonStyle={{
    fontSize: '0.8rem',
    height: '40px',
    borderRadius: '4px 0 0 4px',
    borderColor: '#c4c4c4',
    backgroundColor: userData?.loginMethod === 'mobile' ? '#f5f5f5' : 'inherit',
    cursor: userData?.loginMethod === 'mobile' ? 'not-allowed' : 'pointer',
    pointerEvents: userData?.loginMethod === 'mobile' ? 'none' : 'auto', // Disables click on the button area
  }}
  inputProps={{
    name: 'phone',
    id: 'phone',
    required: true,
    readOnly: userData?.loginMethod === 'mobile',
    tabIndex: userData?.loginMethod === 'mobile' ? -1 : 0,
  }}
  specialLabel={field.label}
  inputClass="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputSizeSmall css-1n4u8gi-MuiInputBase-input-MuiOutlinedInput-input"
/> */}
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      maxWidth: '400px',
                      border: '1.9px solid #ccc',
                      // borderRadius: '25px',
                      borderRadius: '2px',
                      overflow: 'hidden',
                      backgroundColor: '#fff',
                      p: 1,
                      // mb: 4,
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', px: 1, borderRight: '1px solid #eee' }}>
                        <img src={IndianFlag} alt="Indian Flag" style={{ width: '25px', height: '25px', marginRight: '8px' }} />
                        <Typography sx={{ color: '#555' }}>+91</Typography>
                      </Box>
                      <InputBase
                        value={profileData.phone}
                        disabled={userData?.signInMode === 1}
                        onChange={handlePhoneChange}
                        type='tel'
                        placeholder="Enter Mobile Number"
                        sx={{
                          ml: 1,
                          flex: 1,
                          '& .MuiInputBase-input': {
                            fontSize: '14px',
                            color: '#333',
                            padding: '4px 8px',
                          },
                        }}
                        inputProps={{ 'aria-label': 'Enter Mobile Number' }}
                      />
                    </Box>
                  </>
                ) : (

                  <TextField
                    size='small' // Changed back to 'small' for smaller height
                    id={field.id}
                    label={field.label}
                    variant="outlined"
                    fullWidth
                    type={field.type || 'text'}
                    value={profileData[field.id]}
                    onChange={handleChange}
                    disabled={field.id === 'email' && userData?.signInMode === 2}
                    // InputProps={{
                    //   style: { fontSize: '0.8rem' }, // Adjust font size for input text
                    //   ...(field.disabled && {
                    //     endAdornment: (
                    //       <InputAdornment position="end">
                    //         <Typography variant="caption" color="text.secondary">
                    //           {t('Cannot change')}
                    //         </Typography>
                    //       </InputAdornment>
                    //     ),
                    //   })
                    // }}
                    InputLabelProps={{ style: { fontSize: '0.8rem' } }} // Adjust font size for label
                  />
                )}
              </Grid>
            ))}
            {/* Profile Message */}
            {(profileMessage || errorMessage) && (
              <Grid item xs={12}>
                <Typography variant="body2" color={profileMessage ? 'success.main' : 'error.main'} sx={{ textAlign: 'center', mt: 1 }}>
                  {profileMessage || errorMessage}
                </Typography>
              </Grid>
            )}
            {/* Save Button */}
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  backgroundColor: '#f97316',
                  '&:hover': {
                    backgroundColor: '#e06612',
                  },
                  width: '50%',
                  minHeight: '36px', // Adjusted minimum height for the button to align with smaller fields
                  fontSize: '0.9rem' // Slightly reduced font size for button text
                }}
                onClick={handleUpdateProfile}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : t('Save Profile')}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* Image Selection Drawer */}
      <Drawer
        anchor="bottom"
        open={openImageDrawer}
        onClose={handleCloseImageDrawer}
        PaperProps={{
          sx: {
            borderRadius: '16px 16px 0 0',
            maxWidth: 400,
            margin: '0 auto',
          }
        }}
      >
        <Box sx={{
          width: '100%',
          maxWidth: 400,
          margin: '0 auto',
          pb: 4,
          backgroundColor: 'background.paper',
        }}>
          <Typography id="image-selection-drawer-title" variant="h6" component="h2" sx={{ px: 2, pt: 2, pb: 1 }}>
            {t('Choose Image Source')}
          </Typography>
          <List>
            <ListItem button onClick={() => cameraInputRef.current?.click()}>
              <ListItemIcon>
                <CameraAltIcon />
              </ListItemIcon>
              <ListItemText primary={t('Camera')} />
              <input
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                ref={cameraInputRef}
                onChange={handleImageSelect}
              />
            </ListItem>
            <ListItem button onClick={() => fileInputRef.current?.click()}>
              <ListItemIcon>
                <PhotoLibraryIcon />
              </ListItemIcon>
              <ListItemText primary={t('Gallery')} />
              <input
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={handleImageSelect}
              />
            </ListItem>
            <ListItem button onClick={handleCloseImageDrawer}>
              <ListItemIcon>
                <CancelIcon />
              </ListItemIcon>
              <ListItemText primary={t('Cancel')} />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default MobileProfilePage;
